module.exports = __webpack_public_path__ + "img/dizzy.8b5ce351.svg";